import { Controller, useFormContext } from 'react-hook-form';

import FormField from 'components/_core/form/Field';
import Input from 'components/_core/form/Input';
import SunshineCard from 'components/_core/SunshineCard';

import Title from '../../../components/Title';
import { ReasonCompetitionStep } from '../../constants';
import reasonLocales from '../../locales';
import locales from './locales';

const FormStepCompetition = () => {
  const { control, register } = useFormContext();

  return (
    <>
      <Title>{locales.title}</Title>

      <Controller
        control={control}
        name="hasLeftForCompetition"
        render={({ field: { onChange, value } }) => (
          <SunshineCard.RadioGroup onChange={onChange} value={value}>
            <SunshineCard.Group>
              <SunshineCard
                title={locales[ReasonCompetitionStep.Yes]}
                value={ReasonCompetitionStep.Yes}
                variant="radio"
              >
                {value === ReasonCompetitionStep.Yes ? (
                  <FormField
                    label={reasonLocales.tellUsMoreInputLabel}
                    marginTop="space-12"
                  >
                    <Input
                      placeholder={reasonLocales.tellUsMoreInputPlaceholder}
                      {...register('hasLeftForCompetitionExplanation')}
                    />
                  </FormField>
                ) : null}
              </SunshineCard>

              <SunshineCard
                title={locales[ReasonCompetitionStep.No]}
                value={ReasonCompetitionStep.No}
                variant="radio"
              />
            </SunshineCard.Group>
          </SunshineCard.RadioGroup>
        )}
      />
    </>
  );
};

export default FormStepCompetition;
